import angular from "angular";

window.angular = angular;
import '@iim/wip-image-zoom/dist/wip-image-zoom.js';
import 'ui-select/dist/select.min.js';
import 'angular-resource/angular-resource.js';
import 'angular-i18n/angular-locale_de.js';
import 'angular-aria/angular-aria.js';
import 'angular-animate/angular-animate.js';
import 'angular-messages/angular-messages.js';
import 'angular-material/angular-material.js';
import 'angular-sanitize/angular-sanitize.js';
import 'angular-touch/angular-touch.js';
import 'angular-file-saver/dist/angular-file-saver.bundle.min.js';


// create the angular app module
const app = angular.module("eproc", [
    'ngResource',
    'ngSanitize',
    'ngMaterial',
    'ngMessages',
    'wipImageZoom',
    'ngFileSaver',
    'ui.select'
]);


if (sessionStorage.getItem(STORAGE_KEY.USER_TYPE)) {

    /**
     * create an config object
     */
    app.config(require('./angular/app-init.config'));
    require('./angular/material-theme.config')(app);

    /**
     * Provider
     */
    app.provider('translationService', require('./angular/providers/translationProvider.js'));
    app.provider('aclService', require('./angular/providers/acl.provider.js'));
    app.provider('userService', require('./angular/providers/user.provider.js'));
    app.provider('sseService', require('./angular/providers/sse.provider.js'));

    /**
     * Controller
     */
    app.controller('authCtrl', require('./angular/components/auth/auth.controller.js'));
    app.controller('iframeController', require('./angular/components/iframe/iframe.controller.js'));
    app.controller('BeSupplierSettingsCtrl', require('./angular/components/be/supplier/be.supplier.settings.controller.js'));
    app.controller('feInventoryArticleCtrl', require('./angular/components/fe/inventory/fe.inventory.article.controller.js'));
    app.controller('feAccountingToClassificationController', require('./angular/components/fe/accounting/fe.accounting.classification.controller.js'));
    require('./angular/components/fe/parkedinvoice/fe.parkedinvoice.controller.js')(app);
    require('./angular/components/fe/parkedinvoice/fe.showParkedInvoicesTab.controller.js')(app);
    app.controller('feCopyParkedInvoiceToVSL', require('./angular/components/fe/parkedinvoice/fe.copyParkedInvoiceToVSL.controller.js'));
    require('./angular/components/fe/sourcingwaiver/fe.sourcingwaiver.controller.js')(app);
    app.controller('feSourcingWaiverTabCtrl', require('./angular/components/fe/sourcingwaiver/fe.sourcingwaiverTab.controller.js'));
    app.controller('sbeStorageCtrl', require('./angular/components/sbe/storage/sbe.storage.controller.js'));
    app.controller('sbeStorageArticleCtrl', require('./angular/components/sbe/storage/sbe.storage.article.controller.js'));
    app.controller('feUniteSearchCtrl', require('./angular/components/fe/unite/fe.unite.search.controller.js'));
    app.controller('feUniteSearchDetailCtrl', require('./angular/components/fe/unite/fe.unite.search.detail.controller.js'));
    app.controller('feUniteCatalogListController', require('./angular/components/fe/unite/fe.unite.catalog.list.controller.js'));
    app.controller('feBasketItemConstraintsController', require('./angular/components/fe/basket/fe.basket.item.constraints.controller.js'));
    app.controller('feQuotationComparisonDownloadController', require('./angular/components/fe/quotation/fe.quotation.comparison.download.controller.js'));
    app.controller('feLinkOrderController', require('./angular/components/fe/order/link-order.controller.js'));
    require('./angular/components/fe/task/task-redirection.controller.js')(app);
    require('./angular/components/fe/breadcrumbs/breadcrumb.controller.js')(app);
    require('./angular/components/fe/delivery-receipt/unpaid-delivery.controller.js')(app);
    require('./angular/components/fe/demand/rfq-to-demand.controller.js')(app);
    require('./angular/components/fe/demand/basket-to-demand.controller.js')(app);
    require('./angular/components/fe/oci/background-search/search-result-container/oci-background-search-result.controller.js')(app);
    require('./angular/components/fe/task/task-count.controller.js')(app);
    require('./angular/components/fe/warehouse/client/search/client-warehouse-product-search.controller.js')(app);
    require('./angular/components/fe/order_acknowledgement/order-acknowledgement-tab.controller')(app);
    require('./angular/components/fe/order_acknowledgement/order-acknowledgement-create.controller')(app);

    /**
     * Dialogs
     */
    require('./angular/dialogs/account-assignment-detail/account-assignment-detail.dialog.js')(app);
    require('./angular/dialogs/bpmn-display/bpmn-display.dialog.js').DialogComponent(app);
    require('./angular/dialogs/warehouse/client/insert-into-warehouse.dialog.js')(app);

    /**
     * Services
     */
    app.factory('authService', require('./angular/components/auth/auth.service.js'));
    app.factory('BeCustomerGroupAddressService', require('./angular/components/be/customer_group/be.customer.group.address.service.js'));
    app.factory('BeSupplierSettingsService', require('./angular/components/be/supplier/be.supplier.settings.service.js'));
    app.factory('feInventoryArticleService', require('./angular/components/fe/inventory/fe.inventory.article.service.js'));
    app.factory('feProductService', require('./angular/components/fe/product/fe.product.service.js'));
    app.factory('feAccountingToClassificationService', require('./angular/components/fe/accounting/fe.accounting.classification.service.js'));
    app.factory('feParkedInvoiceService', require('./angular/components/fe/parkedinvoice/fe.parkedinvoice.service.js'));
    app.factory('feSourcingWaiverService', require('./angular/components/fe/sourcingwaiver/fe.sourcingwaiver.service.js'));
    app.factory('feSourcingWaiverTabService', require('./angular/components/fe/sourcingwaiver/fe.sourcingwaiverTab.service.js'));
    app.factory('sbeStorageService', require('./angular/components/sbe/storage/sbe.storage.service.js'));
    app.factory('sbeStorageArticleService', require('./angular/components/sbe/storage/sbe.storage.article.service.js'));
    app.factory('feUniteSearchService', require('./angular/components/fe/unite/fe.unite.search.service.js'));
    app.factory('feUniteCatalogService', require('./angular/components/fe/unite/fe.unite.catalog.service.js'));
    app.factory('notificationService', require('./angular/services/notification.service.js'));
    app.factory('basketService', require('./angular/services/basket.service.js'));
    require('./angular/services/delivery-receipt.service.js')(app);
    require('./angular/services/parked-invoice.service.js')(app);
    app.factory('uniteService', require('./angular/services/unite.service.js'));
    app.factory('textModuleService', require('./angular/services/textModule.service.js'));
    app.factory('quotationService', require('./angular/services/quotation.service.js'));
    app.factory('linkOrderService', require('./angular/components/fe/order/link-order.service.js'));
    app.factory('accountAssignmentService', require('./angular/services/account-assignment.service.js'));
    app.factory('headerService', require('./angular/services/header.service.js'));
    require('./angular/services/dialog.service.js')(app);
    require('./angular/services/http.service.js')(app);
    require('./angular/services/task.service.js')(app);
    app.factory('orderService', require('./angular/services/order.service.js'));
    app.factory('rfqService', require('./angular/services/rfq.service.js'));
    app.factory('addressService', require('./angular/services/address.service.js'));
    require('./angular/services/workflow.service')(app);
    require('./angular/services/demand.service')(app);
    require('./angular/services/oci-background-search.service')(app);
    require('./angular/services/process-data.service')(app);
    require('./angular/services/client-warehouse.service.js')(app);
    require('./angular/services/unit.service.js')(app);
    require('./angular/services/order-acknowlegement.service')(app);
    require('./angular/services/feature-toggle.service')(app);

    /**
     * Directives
     */
    app.directive('articleInventoryAvailability', require('./angular/directives/article-inventory.directive/article-inventory-availability.directive.js'));
    app.directive('articleInventoryIcon', require('./angular/directives/article-inventory.directive/article-inventory-icon.directive.js'));
    app.directive('articleInventoryList', require('./angular/directives/article-inventory.directive/article-inventory-list.directive.js'));
    app.directive('filterInputFormGroup', require('./angular/directives/filter.input.form.group.js'));
    require('./angular/directives/loading.directive.js')(app);
    require('./angular/directives/loading.inline.directive.js')(app);
    require('./angular/directives/pagination/bottom/pagination.bottom.directive.js')(app);
    require('./angular/directives/pagination/top/pagination.top.directive.js')(app);
    app.directive('iframeOnload', require('./angular/directives/iFrame/iFrame.on.load.directive.js'));
    app.directive('fileModel', require('./angular/directives/file-model.directive.js'));
    app.directive('uniteReferenceArticle', require('./angular/directives/unite/referenceArticle/unite.reference.article.directive.js'));
    app.directive('textModules', require('./angular/directives/textModule/text-module.directive.js'));
    app.directive('linkOrder', require('./angular/directives/order/link-order.directive.js'));
    app.directive('listLinkedOrders', require('./angular/directives/order/list-linked-orders.directive.js'));
    require('./angular/directives/acl/acl.directive.js')(app);
    require('./angular/directives/account-assignment/account-assignment.directive.js')(app); // todo alles so umstellen
    app.directive('accountAssignmentAutocomplete', require('./angular/directives/account-assignment/account-assignment-autocomplete/account-assignment-autocomplete.directive.js'));
    app.directive('eprocHeader', require('./angular/directives/header/header-container.directive.js'));
    app.directive('eprocHeaderUser', require('./angular/directives/header/sub-elements/shared/user/header-user-element.directive.js'));
    app.directive('mobileSidenav', require('./angular/directives/header/sidenav/mobile-sidenav.directive.js'));
    app.directive('headerAdmin', require('./angular/directives/header/sub-elements/admin/header-admin-elements.directive.js'));
    app.directive('headerClient', require('./angular/directives/header/sub-elements/client/header-client-elements.directive.js'));
    app.directive('headerSupplier', require('./angular/directives/header/sub-elements/supplier/header-supplier-elements.directive.js'));
    app.directive('headerDropdowns', require('./angular/directives/header/sub-elements/header-dropdown/header-dropdown.directive.js'));
    app.directive('headerSupplierDropdowns', require('./angular/directives/header/sub-elements/supplier/dropdown/header-supplier-dropdown.directive.js'));
    app.directive('headerClientBasket', require('./angular/directives/header/sub-elements/client/basket/header-client-basket.directive.js'));
    app.directive('headerClientNews', require('./angular/directives/header/sub-elements/client/news/header-client-news.directive.js'));
    app.directive('headerClientQuotation', require('./angular/directives/header/sub-elements/client/quotation/header-client-quotation.directive.js'));
    app.directive('headerClientSearch', require('./angular/directives/header/sub-elements/client/search/header-client-search.directive.js'));
    app.directive('headerClientVacationReplacement', require('./angular/directives/header/sub-elements/client/vacationReplacement/header-client-vacation-replacement.directive.js'));
    require('./angular/directives/task/widget/task-counter.directive.js')(app);
    app.directive('enterPressed', require('./angular/directives/key-event/enterPressed.directive.js'));
    app.directive('enterPressed', require('./angular/directives/key-event/tabPressed.directive.js'));
    app.directive('addressSelection', require('./angular/directives/address/address-selection.directive.js'));
    app.directive('companyAddress', require('./angular/directives/address/address.directive.js'));
    require('./angular/directives/oci/background-search/catalog/oci-background-search-catalog.directive.js')(app);
    require('./angular/directives/process-bpmn/process-bpmn.directive.js')(app);
    require('./angular/directives/process-definition-bpmn/process-definition-bpmn.directive.js')(app);
    require('./angular/directives/warehouse/client/insert/insert-into-warehouse-btn.directive.js')(app);
    require('./angular/directives/warehouse/client/level/warehouse-level.directive.js')(app);
    require('./angular/directives/feature-toggle/feature-toggle.directive')(app);

    /**
     * Filter
     */
    app.filter('unitePrice', require('./angular/filter/unite.price.format.filter.js'));
    app.filter('uniteAmount', require('./angular/filter/unite.amount.format.filter.js'));
    app.filter('booleanToString', require('./angular/filter/boolean.to.string.filter.js'));
    app.filter('stringPreview', require('./angular/filter/string.preview.filter.js'));
    app.filter('customAccountAssignmentTranslation', require('./angular/filter/account-assignment/custom/custom-account-assignment-translation.filter.js'));
    app.filter('highlight', require('./angular/filter/highlight.filter.js'));
    app.filter('sanitize', require('./angular/filter/sanitize.filter'));
    app.filter('moment', require('./angular/filter/moment.filter.js'));
    app.filter('translate', require('./angular/filter/translateFilter.js'));
    require('./angular/filter/unit.filter.js')(app)
}
